import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { BackButton, Form, Header, HistoryButton } from 'shared/components'
import { useRentalValidationSchema } from 'features/rentals/hooks/useRentalValidationSchema'
import { RentalFormSections } from 'features/rentals/organisms/RentalForm/RentalFormSections'
import { toRentalPayload } from 'features/rentals/utils/toRentalPayload'
import { useEditRentalMutation } from './mutations/useEditRentalMutation'
import { useFetchRental } from './queries/useFetchRental'
import { usePopulateRental } from './hooks/usePopulateRental'

const RentalPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const validationResolver = useRentalValidationSchema()

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const { handleSubmit, reset } = form

	const { rental } = useFetchRental()

	usePopulateRental({
		rentalData: rental?.data,
		reset
	})

	const { editRental, editRentalLoading } = useEditRentalMutation()

	return (
		<>
			<Header
				title={t('Edit rental')}
				eyebrow={t('Booking engine')}
				actions={
					<>
						<BackButton to={routes.rentalIndex} text={t('Back to rentals')} />
						<HistoryButton to={routes.rentalHistory(params.id)} />
					</>
				}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Save changes')}
					cancelText={t('Discard changes')}
					onCancel={() => reset()}
					onSubmit={handleSubmit((data) => editRental(toRentalPayload(data)))}
					isLoading={editRentalLoading}>
					<RentalFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default RentalPage
